import socket from './socket';

/* Transformers */

export const transformUserRoleAssignment = (userRoleAssignment) => ({
  ...userRoleAssignment,
  createdAt: new Date(userRoleAssignment.createdAt),
  updatedAt: userRoleAssignment.updatedAt ? new Date(userRoleAssignment.updatedAt) : null,
  expiresAt: userRoleAssignment.expiresAt ? new Date(userRoleAssignment.expiresAt) : null,
});

/* Actions */

const createUserRoleAssignment = (data, headers) =>
  socket.post('/user-role-assignments', data, headers).then((body) => ({
    ...body,
    item: transformUserRoleAssignment(body.item),
  }));

const updateUserRoleAssignment = (id, data, headers) =>
  socket.patch(`/user-role-assignments/${id}`, data, headers).then((body) => ({
    ...body,
    item: transformUserRoleAssignment(body.item),
  }));

const deleteUserRoleAssignment = (id, headers) =>
  socket.delete(`/user-role-assignments/${id}`, undefined, headers).then((body) => ({
    ...body,
    item: transformUserRoleAssignment(body.item),
  }));

/* Event handlers */

const makeHandleUserRoleAssignmentCreate = (next) => (body) => {
  next({
    ...body,
    item: transformUserRoleAssignment(body.item),
  });
};

const makeHandleUserRoleAssignmentUpdate = makeHandleUserRoleAssignmentCreate;

const makeHandleUserRoleAssignmentDelete = makeHandleUserRoleAssignmentCreate;

export default {
  createUserRoleAssignment,
  updateUserRoleAssignment,
  deleteUserRoleAssignment,
  makeHandleUserRoleAssignmentCreate,
  makeHandleUserRoleAssignmentUpdate,
  makeHandleUserRoleAssignmentDelete,
};
